import { render, staticRenderFns } from "./Yatirim.vue?vue&type=template&id=78ea7b41&scoped=true&"
import script from "./Yatirim.vue?vue&type=script&lang=js&"
export * from "./Yatirim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ea7b41",
  null
  
)

export default component.exports